module.exports = __webpack_public_path__ + "img/WiiMenu.65fc0594.png";